import { render, staticRenderFns } from "./dormitory.vue?vue&type=template&id=5ec2b1a4&"
import script from "./dormitory.vue?vue&type=script&lang=js&"
export * from "./dormitory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports